var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._b({attrs:{"aria-hidden":"true","width":_setup.props.size,"height":_setup.props.size,"viewBox":"0 0 24 24","data-icon":_vm.icon}},'svg',_vm.$attrs,false),[_c(_setup.ICON_SET[_setup.props.icon],{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }